import React, { useRef } from 'react';
import { View, Image, StyleSheet, TouchableOpacity } from 'react-native';
import { themes } from '../../theme/theme';
import Typography from '../Text/Text';
import union from '../../assets/Union.png';

interface CameraCardProps {
  onImageSelected?: (image: string | null) => void; // Callback to return the image
  fileType?: 'image' | 'pdf';
  text: string;
  testID?: string;
}

const CameraCard: React.FC<CameraCardProps> = ({
  onImageSelected,
  text,
  fileType = 'image',
  testID,
}) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        if (onImageSelected) {
          onImageSelected(reader.result as string); // Return the image to the parent component
        } else {
          console.error('Error, onImageSelected callback is not defined.');
        }
      };
      reader.readAsDataURL(file); // Convert the file to a Base64 string
    }
  };

  const handleOpenFileInput = () => {
    fileInputRef.current?.click(); // Trigger the file input programmatically
  };

  return (
    <TouchableOpacity style={styles.card} onPress={handleOpenFileInput} testID={testID}>
      <input
        ref={fileInputRef}
        type="file"
        accept={fileType === 'image' ? 'image/*' : '.pdf'}
        onChange={handleFileChange}
        style={styles.input}
      />
      <View style={styles.imageBox}>
        <Image source={union} style={styles.image} />
      </View>
      <Typography variant="body2" style={styles.text}>
        {text}
      </Typography>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  card: {
    height: 104,
    borderWidth: 2,
    borderStyle: 'dotted',
    borderColor: themes.light.gray_blue[6],
    borderRadius: 12,
    //this color is not in our design system
    backgroundColor: `#F8F9FB`,
    justifyContent: 'center',
    alignItems: 'center',
  },
  imageBox: {
    width: 32,
    height: 32,
    justifyContent: 'center',
    alignItems: 'center',
  },
  image: {
    width: 27,
    height: 25,
  },
  text: {
    marginTop: 8,
    textAlign: 'center',
  },
  input: {
    display: 'none',
  },
});

export default CameraCard;
